<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : '#000'" :class="[`${prefix}-icon`, `${prefix}-icon-cloud-space`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M39 3a1 1 0 011 1v20.187a10.248 10.248 0 00-4-1.156V7H8v34l10.31.001a8.32 8.32 0 002.495 4L5 45a1 1 0 01-1-1V4a1 1 0 011-1h34zm-4.098 24c4.059 0 7.403 3.15 7.855 7.204C44.67 35.086 46 37.061 46 39.357c0 3.093-2.416 5.604-5.41 5.643H28.034C24.703 45 22 42.218 22 38.786c0-3.206 2.358-5.845 5.385-6.179C28.42 29.352 31.395 27 34.902 27zm0 4c-1.674 0-3.17 1.135-3.705 2.819l-.788 2.479-2.586.285c-1.005.11-1.823 1.042-1.823 2.203 0 1.248.938 2.214 2.035 2.214h12.503c.783-.01 1.462-.717 1.462-1.643 0-.684-.377-1.27-.918-1.52l-2.05-.946-.25-2.244C38.549 32.558 36.864 31 34.902 31zM21 21a1 1 0 01.993.883L22 22v2l-.007.117a1 1 0 01-.876.876L21 25h-6l-.117-.007a1 1 0 01-.876-.876L14 24v-2l.007-.117a1 1 0 01.876-.876L15 21h6zm8-8a1 1 0 01.993.883L30 14v2l-.007.117a1 1 0 01-.876.876L29 17H15l-.117-.007a1 1 0 01-.876-.876L14 16v-2l.007-.117a1 1 0 01.876-.876L15 13h14z"/></svg>
</template>
<script>

export default {
  name: 'IconCloudSpace',
  props: {
    prefix: {
        type: String,
        default: 'arco',
    },
    useCurrentColor: {
        type: Boolean,
        default: true,
    },
  },
};
</script>
